import { render, staticRenderFns } from "./nav-tabs.vue?vue&type=template&id=2a4c6725&"
import script from "./nav-tabs.vue?vue&type=script&lang=js&"
export * from "./nav-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports